import { render } from "./Profile.vue?vue&type=template&id=c3b79a9e"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=c3b79a9e&lang=scss"

import exportComponent from "D:\\Nerd\\RumbleFish\\Website\\Code\\rumblefish\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__